import { Badge } from "@minuthq/meatball-ui-react"

import { ParadiseTable } from "src/components/Paradise/ParadiseTable"
import { getStockBadgeColor } from "src/components/Paradise/ParadiseWarehouses/paradiseWarehousesUtils"
import { StatusWrapper } from "src/components/Paradise/sharedStyles"
import { TWarehouse } from "src/data/ecommerce/ecommerceTypes"
import {
  TableColumn,
  useTableColumns,
} from "src/ui/GridTable/useTableColumns/useTableColumns"

export function ParadiseWarehouseInventory({
  warehouse,
}: {
  warehouse: TWarehouse
}) {
  const tableColumns: TableColumn<TWarehouse["articles"][number], string>[] = [
    {
      label: "SKU",
      value: "sku",
      renderCell: (data) => <div>{data.sku}</div>,
    },
    {
      label: "Stock quantity",
      value: "stock_quantity",
      renderCell: (data) => {
        const isLowStock = data.stock_quantity <= data.low_stock_threshold
        const isOutOfStock = data.stock_quantity <= data.out_of_stock_threshold

        return (
          <div>
            <StatusWrapper>
              <div>{data.stock_quantity}</div>
              <Badge
                color={getStockBadgeColor({
                  stockQuantity: data.stock_quantity,
                  lowStockThreshold: data.low_stock_threshold,
                  outOfStockThreshold: data.out_of_stock_threshold,
                })}
                size="x-small"
              >
                {isOutOfStock
                  ? "Out of stock"
                  : isLowStock
                    ? "Low stock"
                    : "In stock"}
              </Badge>
            </StatusWrapper>
          </div>
        )
      },
    },
    {
      label: "Low stock threshold",
      value: "low_stock_threshold",
      renderCell: (data) => <div>{data.low_stock_threshold}</div>,
    },
    {
      label: "Out of stock threshold",
      value: "out_of_stock_threshold",
      renderCell: (data) => <div>{data.out_of_stock_threshold}</div>,
    },
  ]

  const { headerElements, rows, templateColumns } = useTableColumns({
    columns: tableColumns,
    data: warehouse.articles,
  })

  return (
    <ParadiseTable
      header={headerElements}
      rows={rows}
      templateColumns={templateColumns}
      isLoading={false}
    />
  )
}
